module.exports = __webpack_public_path__ + "static/media/instagram.2bcf2721.svg";